import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { whatsappLink } from '../mock';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
  { name: 'Início', path: '/' },
  { name: 'Serviços', path: '/#servicos' },
  { name: 'Orçamento', path: '/#orcamento' },
  { name: 'Dicas', path: '/#dicas' },
  { name: 'Área do Cliente', path: '/area-cliente' },
  { name: 'Contato', path: '/#contato' }];


  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleNavClick = (path) => {
    if (path.includes('#')) {
      const sectionId = path.split('#')[1];
      if (location.pathname !== '/') {
        window.location.href = path;
      } else {
        scrollToSection(sectionId);
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl sm:px-6 lg:px-8 mx-auto px-4 !bg-[#F4D03F]">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_express-delivery-98/artifacts/6aux7qgk_Logotipo%20VIBE%20LOG.png"
              alt="VIBE LOG"
              className="h-14 w-auto" />

          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) =>
            item.path.includes('#') ?
            <button
              key={item.name}
              onClick={() => handleNavClick(item.path)}
              className="text-gray-700 hover:text-[#0A2540] font-medium transition-colors">

                  {item.name}
                </button> :

            <Link
              key={item.name}
              to={item.path}
              className="text-gray-700 hover:text-[#0A2540] font-medium transition-colors">

                  {item.name}
                </Link>

            )}
          </nav>

          <div className="hidden md:block">
            <Button
              asChild
              className="bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold px-6">

              <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                Fale no WhatsApp
              </a>
            </Button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-[#0A2540]">

            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {isMenuOpen &&
        <div className="md:hidden pb-4">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) =>
            item.path.includes('#') ?
            <button
              key={item.name}
              onClick={() => handleNavClick(item.path)}
              className="text-left text-gray-700 hover:text-[#0A2540] font-medium transition-colors">

                    {item.name}
                  </button> :

            <Link
              key={item.name}
              to={item.path}
              onClick={() => setIsMenuOpen(false)}
              className="text-gray-700 hover:text-[#0A2540] font-medium transition-colors">

                    {item.name}
                  </Link>

            )}
              <Button
              asChild
              className="bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold">

                <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                  Fale no WhatsApp
                </a>
              </Button>
            </nav>
          </div>
        }
      </div>
    </header>);

};